import React, { useState, useEffect, useContext } from 'react'

import Banner from '../component/Common/Banner'
import { withRouter } from 'react-router-dom';
import { useTranslation} from 'react-i18next';
import { compose } from 'redux'
import DepartmentDetail from '../component/About/DepartmentDetail'
import { connect } from "react-redux";
import * as department from "../actions/department";

const Department = (props) => {
    const { t, i18n } = useTranslation();
    useEffect(() => {
      
        props.fetchDepartments();
 
        
      }, []);
    return (
        <>
         
            <Banner title={t('departments')} />
            <DepartmentDetail TeamData={props.departments} />

           
        </>
    )
}


const mapStateToProps = state => ({
    departments: state?.department?.departments,
    meta: state?.department?.metaDepartment,

})

const mapActionToProps = {
 
    fetchDepartments : department.fetchAll,
  
}


export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
  )(Department);